import React from 'react';
import { IS_BETA } from '../../lib/constants';
interface LogoProps {
  className?: string;
  onClick?: () => void;
}
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/69qXuyQ66NyQD7aidYw85T/Izio.svg';
function BetaBadge() {
  return <span className="inline-flex items-center px-1.5 sm:px-2 h-4 sm:h-[18px] rounded-full border border-lime-1 text-lime-1 text-[9px] sm:text-[10px] font-bold tracking-[0.12em] leading-none uppercase" aria-label="Beta" data-id="element-2235">
      Beta
    </span>;
}
export function Logo({
  className,
  onClick
}: LogoProps) {
  // Tighter default heights — 24px on mobile, 28px on desktop.
  const imgCls = className ?? 'h-6 sm:h-7 w-auto';
  const inner = <span className="inline-flex items-center gap-1.5 sm:gap-2" data-id="element-2236">
      <img src={LOGO_URL} alt="Izio" className={imgCls} data-id="element-2237" />
      {IS_BETA && <BetaBadge data-id="element-2238" />}
    </span>;
  if (onClick) {
    return <button onClick={onClick} className="cursor-pointer inline-flex items-center" aria-label="Izio — pagina principală" data-id="element-2239">
        {inner}
      </button>;
  }
  return inner;
}